import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'html-to-pdf',
  name: 'HTML to PDF',
  category: 'files',
  description: 'Convert HTML content to PDF document. Supports various page sizes, orientations, and margins.',
  icon: 'FileText',
  iconType: 'lucide',
  color: 'red',
  version: '1.0.0',

  group: ['output'],

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: false,
    },
  ],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  subtitle: '={{ $parameter.fileName || "document.pdf" }}',

  tags: ['pdf', 'html', 'convert', 'document', 'export', 'file'],
};

export default definition;
